<template>
  <div class="close-upgrade__page">
    <Head hideMenu></Head>
    <div class="close-upgrade__container">
      <img src="@/assets/images/close-upgrade-icon.png" alt="">
      <h4>{{ tipContent }}</h4>
    </div>
  </div>
</template>
<script>
import Head from "@/components/common/Header.vue";
export default {
  components: {
    Head,
  },
  computed: {
    tipContent() {
      return this.$Tool.getStorage('SchoolTemporaryCloseTip')
    }
  }
};
</script>
<style lang="less" scoped>
.close-upgrade__page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .close-upgrade__container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 332px;
      height: 242px;
    }

    h4 {
      max-width: 500px;
      margin-top: 30px;
      text-align: center;
      font-size: 18px;
      color: #303133;
      line-height: 25px;
    }
  }
}
</style>
